import * as consts from '../data/base/consts'

/**
 * 一些公共的方法
 */
import { LS } from './ls'
import { UA } from './ua'
import { SCHEME } from './scheme'
import { COOKIE } from './cookie'
import { MOMENT_TIME } from '../momenttime'
import { CONFIG } from '../config'

var UTILS = {
    // 强制补齐两位小数点
    toDecimal2(x) { 
        var f = parseFloat(x); 
        if (isNaN(f)) { 
            return false; 
        } 
        var f = Math.round(x*100)/100; 
        var s = f.toString(); 
        var rs = s.indexOf('.'); 
        if (rs < 0) { 
            rs = s.length; 
            s += '.'; 
        } 
        while (s.length <= rs + 2) { 
            s += '0'; 
        } 
        return s; 
    },
    // 获取时间格式
    getTimeStrByInt(num) {
        num = !num ? 0 : parseInt(num);
        return num < 10 ? ('0' + num) : num;
    },
    // 获取星期几的时间格式
    getWeekStrByInt(num) {
        var str = '星期';
        if(num == 0){
            str += '日';
        }else {
            str += consts.CONST_YEAR_WORD[num];
        }
        return str;
    },
    // 根据数组获取 yy-mm-dd hh:mm:ss 格式的时间
    getYmdHmsTimeStrByArr(arr) {
        var timeStr = '';
        for(var i = 0; i < arr.length; i++){
            timeStr += this.getTimeStrByInt(arr[i]);
            if(i < 2){
                timeStr += '-';
            }else if (i == 2){
                timeStr += ' ';
            }else if (i == 3 || i == 4){
                timeStr += ':';
            }
        }
        return timeStr;
    },
    // 根据数组获取 大运开始日期string 
    getDaYunStartTimeStrByData(data) {
        var str = data.y + '年';
            str = str + this.getTimeStrByInt(data.m) + '月';
            str = str + this.getTimeStrByInt(data.d) + '日';
            str = str + this.getTimeStrByInt(data.h) + '时';
            str = str + this.getTimeStrByInt(data.i) + '分交大运';
        return str;
    },
    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURI(r[2]);
        };
        return null;
    },
    // 校验是否是正确手机号码
    isPoneAvailable(number) {
        var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(number)) {
            return false;
        } else {
            return true;
        }
    },
    // 数组去重
    distinct(arr) {
        var result = [];
        var obj = {};
    
        for (var i of arr) {
            if (!obj[i]) {
                result.push(i);
                obj[i] = 1;
            }
        }
        return result;
    },
    // 在数组中查找是否有某对象
    checkArrayInArray(origiArr, arr) {
        for(var i = 0; i < origiArr.length; i++){
            if(origiArr[i][0] == arr[0]){
                return true;
            }
        }
        return false;
    },
    // 在数组中获取某个数组的index值
    getArrayIndexInArray(origiArr, arr) {
        for(var i = 0; i < origiArr.length; i++){
            if(origiArr[i][0] == arr[0]){
                return i;
            }
        }
        return -1;
    },
    // 在对象数组里取包含特定id的object的index
    getIdIndexInObjectArray(objectArr, id) {
        return _.findIndex(objectArr, function(o) { return o.id == id; });
        // for(var object of objectArr){
        //     var index = objectArr.indexOf(object);
        //     if(object.id == id){
        //         return index;
        //     }
        // }
        // return -1;
    },
    // 在字符串对象里获取某个存在目标字符的字符串的索引值
    getTextIndexInStringArray(arr, text) {
        for(var i = 0; i < arr.length; i++){
            if(arr[i].indexOf(text) != -1){
                return i;
            }
        }
    },
    /**
     * 获得指定数组的特定组合
     * @param {目标数组} targetArr 
     * @param {组合个数} num 
     */
    getCombineArrayByNum(targetArr, num) {
        if(!targetArr || !targetArr.length) {
            return [];
        }
    
        var len = targetArr.length;
        var resultArrs = [];
    
        // 所有组合
        var flagArrs = this.getFlagArrs(len, num);
        while(flagArrs.length) {
            var flagArr = flagArrs.shift();
            var combArr = [];
            for(var i = 0; i < len; i++) {
                flagArr[i] && combArr.push(targetArr[i]);
            }
            resultArrs.push(combArr);
        }
        return resultArrs;
    },
    /**
     * 获得从m中取n的所有组合
     */
    getFlagArrs(m, n) {

        if(!n || n < 1) {
            return [];
        }
    
        var resultArrs = [],
            flagArr = [],
            isEnd = false,
            i, j, leftCnt;
    
        for (i = 0; i < m; i++) {
            flagArr[i] = i < n ? 1 : 0;
        }
        resultArrs.push(flagArr.concat());
    
        while (!isEnd) {
            leftCnt = 0;
            for (i = 0; i < m - 1; i++) {
                if (flagArr[i] == 1 && flagArr[i+1] == 0) {
                    for(j = 0; j < i; j++) {
                        flagArr[j] = j < leftCnt ? 1 : 0;
                    }
                    flagArr[i] = 0;
                    flagArr[i+1] = 1;
                    var aTmp = flagArr.concat();
                    resultArrs.push(aTmp);
                    if(aTmp.slice(-n).join("").indexOf('0') == -1) {
                        isEnd = true;
                    }
                    break;
                }
                flagArr[i] == 1 && leftCnt++;
            }
        }
        return resultArrs;
    },
    /**
     * 给年补齐4位数
     * @param {年} $yy 
     */
    formatYearNum: function ($yy) {
        var $num = 4 - $yy.toString().length;
        for(var $i = 0; $i < $num; $i++){
            $yy = '0' + $yy;
        }
        return $yy;
    },
    /**
     * 通过文本获得换行符
     * @param {文本} text 
     */
    getBreakLineByText(text) {
        if(!text) { return '' };
        var regex = /\n/gi;
        var newText = text.replace(regex, '<br />');
        return newText;
    },
    /**
     * 检测标签id是否完全相等
     * @param {a标签} aLabel 
     * @param {b标签} bLabel 
     */
    getLabelStringEqual(aLabel, bLabel) {
        var aArr = [], bArr = [];
        if(aLabel && aLabel != '') {
            aArr = aLabel.split(',');
            aArr = aArr.sort((a, b) => a - b);
            aLabel = aArr.join(',');
        }
        if(bLabel && bLabel != '') {
            bArr = bLabel.split(',');
            bArr = bArr.sort((a, b) => a - b);
            bLabel = bArr.join(',');
        }
        return aLabel.indexOf(bLabel) != -1;
    },
    getLabelStringIncludeLabel(aLabel, bLabel) {
        var aArr = aLabel && aLabel != '' ? aLabel.split(',') : [], 
            bArr = bLabel && bLabel != '' ? bLabel.split(',') : [];
        if(aArr.length == 0 || bArr.length == 0) { return; }
        // console.error('------', aArr, bArr)
        for(var i = 0; i < aArr.length; i++) {
            if(bArr.indexOf(aArr[i]) != -1) {
                return true;
            }
        }
        return false;
    },
    /**
     * 根据时间字符串获取时间信息
     * 今天显示今天，1-7天显示N天前，
     * 超过七天前就显示日期，今年只显示月日，
     * 今年之前显示年月日
     * @param {时间字符串} timeStr 
     */
    getTimeInfoByTimeString(timeStr) {
        // for test
        // timeStr = '2020-01-09 09:23:41';
        // for test
        var nowDate = MOMENT_TIME.getUnixTimeByTimeStr(),
            nowArr = MOMENT_TIME.getTimeArrayByTimeStamp(),
            timeDate = MOMENT_TIME.getUnixTimeByTimeStr(timeStr),
            timeArr = timeStr.slice(0, 10).split('-'),
            diffTime = nowDate - timeDate,
            diffDay = diffTime / (3600 * 24);
        var resultStr = diffDay == 0 ? '刚刚' : '';
            resultStr = diffDay > 0 && diffDay < 1 ? '今天' : resultStr;
            resultStr = diffDay > 1 && diffDay < 7 ? (parseInt(diffDay) + '天前') : resultStr;
            resultStr = diffDay > 7 && diffDay < 365 && timeArr.length > 0 ? (timeArr[1]+'-'+timeArr[2]) : resultStr;
            resultStr = nowArr.length > 0 && timeArr.length > 0 && nowArr[0] > timeArr[0] ? (timeArr[0]+'-'+timeArr[1]+'-'+timeArr[2]) : resultStr;
        return resultStr;
    },
    /**
     * 复制文本到剪切板s
     * @param {文本} text 
     * @param {复制成功后回调函数} cb 
     */
    copyTextToClipboard(text, cb) {
        const input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', text);
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, 9999);
        var me = this;
        setTimeout(() => {
            if (document.execCommand('copy')) {
                document.execCommand('copy');
                console.log('复制成功');
                if(cb && typeof(cb) == 'function') {
                    cb();
                }
            }
            document.body.removeChild(input);
        }, 20);
    },
    /**
     * url地址转换
     */
    getQQUrlByCurrentPath(curPathname) {
        var newUrl = CONFIG.qq_url;
        if(curPathname != '/') {
            curPathname = curPathname.replace('/', '?path=');
            curPathname = curPathname.replace(/\//g, '-')
            newUrl = newUrl + curPathname;
        }
        console.log('getQQUrlByCurrentUrl--------', curPathname, newUrl)
        return newUrl;
    },
    getWechatUrlByCurrentPath(curPathname) {
        var newUrl = CONFIG.wechat_url;
        if(!curPathname) { return newUrl; }
        if(curPathname.indexOf('share-detail') != -1) {
            curPathname = curPathname.replace('-', '/');
            curPathname = curPathname.replace('-', '/');
        }else {
            curPathname = curPathname.replace(/-/g, '/');
        }
        newUrl = newUrl + curPathname;
        console.error('getWechatUrlByCurrentPath------', newUrl)
        return newUrl;
    },
    /**
     * 获取分页
     * @param {*} total 
     * @param {*} cur 
     * @param {*} around 
     */
    makePage(total, cur, around) {
        var result = [];
        var baseCount = around * 2 + 1 + 2 + 2 + 2; //总共元素个数
        var surplus = baseCount - 4; //只出现一个省略号 剩余元素个数
        var startPosition = 1 + 2 + around + 1;//前面出现省略号的临界点
        var endPosition = total - 2 - around - 1;//后面出现省略号的临界点
    
        if(total <= baseCount - 2){ //全部显示 不出现省略号
            result =  Array.from({length: total}, (v, i) => i + 1);
        }else{ //需要出现省略号
            if(cur < startPosition){ //1.只有后面出现省略号
                result = [...Array.from({length: surplus}, (v, i) => i + 1),"...",total]
            }else if(cur > endPosition) { //2.只有前边出现省略号
                result = [1,'...',...Array.from({length: surplus}, (v, i) => total - surplus + i + 1)]
            }else{ //3.两边都有省略号
                result = [1,'...',...Array.from({length: around * 2 + 1}, (v, i) => cur - around + i),'...',total]
            }
        }
        return result
    }

}

export {
    UTILS, LS, UA, SCHEME, COOKIE
}